'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'skull-cow';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f8de';
var svgPathData = 'M603.26,4.58a16,16,0,0,0-26.21,17c6.07,16.12,19.6,67.59,2.88,91.7C573.13,123.05,561.4,128,544,128l-73-.18A63.73,63.73,0,0,0,416,96H224a63.71,63.71,0,0,0-55.12,32H96c-17.35,0-29.08-4.93-35.88-14.7C43.35,89.22,56.49,38.92,63,21.57a16,16,0,0,0-26.19-17C13.05,27.81,0,60.17,0,95.7,0,166.18,57.43,224,128,224H160v80a64,64,0,0,0,64,64l26.4,118.93A32,32,0,0,0,281.6,512h76.66A32,32,0,0,0,389.49,487L416,368a64,64,0,0,0,64-64V224h32c70.59,0,128-57.83,128-128.3C640,60.18,627,27.82,603.26,4.58ZM160,192H128c-35.51,0-66.56-19.77-83.19-48.45C55.44,152.38,71.6,160,96,160h64ZM448,304a32,32,0,0,1-32,32H390.3l-5.58,25.05L358.26,480H281.6L255.2,361.07,249.64,336H224a32,32,0,0,1-32-32V160a32,32,0,0,1,32-32H416a32,32,0,0,1,32,32Zm64-112H480V160c0-.07,0-.13,0-.19L544,160c24.36,0,40.5-7.6,51.11-16.43C578.52,172.23,547.47,192,512,192ZM256,224a32,32,0,1,0,32,32A32,32,0,0,0,256,224Zm128,0a32,32,0,1,0,32,32A32,32,0,0,0,384,224Z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSkullCow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;